import { createContext, useContext, useEffect } from "react";

export const AccountWorkspaceActionsContext = createContext<{
  signOut(): Promise<void>;
  switchClinic(siteId: string): Promise<void>;
  clinicSwitchBlocker: string | null;
  setAccountDirty?(dirty: boolean): void;
} | null>(null);
export function useAccountWorkspaceActions() {
  return useContext(AccountWorkspaceActionsContext);
}

/** Logout must check drafts before ending authentication, which unmounts route guards. */
export function useAccountDraftGuard(dirty: boolean) {
  const report = useAccountWorkspaceActions()?.setAccountDirty;
  useEffect(() => {
    report?.(dirty);
    return () => report?.(false);
  }, [dirty, report]);
}
